<template>
  <div>
    <form data-vv-scope="mu" @submit.prevent="onSubmit">
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label for="" class="control-label">Organization Name:</label>
            <input name="" type="text" class="form-control" v-model="accounts.organizationName" readonly="readonly">
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="" class="control-label">Activation Date:</label>
            <date-picker v-model="activationDate"
                         :disabled="true"
                         lang="en"
                         :value-type="'format'"
                         :confirm="false"
                         prefix-class="xmx"
                         :format="calendarFormat"
                         :local="local">
            </date-picker>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="" class="control-label">System ID:</label>
            <input name="" type="text" class="form-control" v-model="accounts.systemId" readonly="readonly">
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="" class="control-label">Users limit:</label>
            <input name="" type="text" class="form-control" v-model="accounts.usersLimit" readonly="readonly">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="" class="control-label">CaseMGR Account URL:</label>
            <input name="" type="text" class="form-control" v-model="accounts.data.accountUrl" readonly="readonly">
          </div>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-md-12">
          <span class="caption-subject bold uppercase">Create New Users</span><br><br>
          <div class="form-group" :class="{ 'has-error': errors.has('mu.fullName') }">
            <label for="" class="control-label">* Full Name:</label>
            <input name="fullName" v-model="user.fullName" type="text" data-vv-as="Full Name" v-validate="'required'"
                   class="form-control">
            <span v-show="errors.has('mu.fullName')" class="help-block">{{ errors.first('mu.fullName') }}</span>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group" :class="{ 'has-error': errors.has('mu.email') }">
            <label for="" class="control-label">* Email Address:</label>
            <input name="email" v-model="user.email" type="text" data-vv-as="Email Address" v-validate="'required'"
                   class="form-control">
            <span v-show="errors.has('mu.email')" class="help-block">{{ errors.first('mu.email') }}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <br>
          <span class="caption-subject bold uppercase">Access</span><br><br>
          <table class="table table-light table-hover">
            <tbody>
            <tr>
              <td><b>Volunteer</b> - This access allows users to view the Participant Dashboard, and enter and view Participant forms.
              </td>
              <td>
                <div class="mt-radio-inline">
                  <label class="mt-radio">
                    <input type="radio" value="2" name="userradio-2" v-model="picked"> Yes
                    <span></span>
                  </label>
                  <label class="mt-radio">
                    <input type="radio" value="0" name="userradio-2" class="userradio-no" disabled="disabled"> No
                    <span></span>
                  </label>
                </div>
              </td>
            </tr>
            <tr>
              <td><b>Case Manager</b> - This access includes Volunteer privileges and allows users to add new
                {{ participantPluralName.toLowerCase() }} and assignments, enter, edit, delete and view forms, generate reports, and modify the
                {{ participantSingularName }}’s Assignment page.
              </td>
              <td>
                <div class="mt-radio-inline">
                  <label class="mt-radio">
                    <input type="radio" value="3" name="userradio-3" v-model="picked"> Yes
                    <span></span>
                  </label>
                  <label class="mt-radio">
                    <input type="radio" value="0" name="userradio-3" class="userradio-no" checked="checked"
                           disabled="disabled"> No
                    <span></span>
                  </label>
                </div>
              </td>
            </tr>
            <tr>
              <td><b>Supervisor</b> - This access includes Case Manager privileges and allows users to view a Caseload Summary for each Case Manager, view the Referral Dashboard, and create, edit, generate, and publish reports.
              </td>
              <td>
                <div class="mt-radio-inline">
                  <label class="mt-radio">
                    <input type="radio" value="4" name="userradio-4" v-model="picked"> Yes
                    <span></span>
                  </label>
                  <label class="mt-radio">
                    <input type="radio" value="0" name="userradio-4" class="userradio-no" checked="checked"
                           disabled="disabled"> No
                    <span></span>
                  </label>
                </div>
              </td>
            </tr>
            <tr>
              <td><b>Program Administrator</b> - This access includes Supervisor privileges and allows users to access
                Administrative Settings, manage users, import data, and create, edit, generate and publish forms.
              </td>
              <td>
                <div class="mt-radio-inline">
                  <label class="mt-radio">
                    <input type="radio" value="5" name="userradio-5" v-model="picked"> Yes
                    <span></span>
                  </label>
                  <label class="mt-radio">
                    <input type="radio" value="0" name="userradio-5" class="userradio-no" checked="checked"
                           disabled="disabled"> No
                    <span></span>
                  </label>
                </div>
              </td>
            </tr>
            <tr v-if="logged.access > 5">
              <td><b>System Administrator</b> - This access includes Program Administrator privileges and allows users
                to access all accounts and functionality.
              </td>
              <td>
                <div class="mt-radio-inline">
                  <label class="mt-radio">
                    <input type="radio" value="6" name="userradio-6" v-model="picked"> Yes
                    <span></span>
                  </label>
                  <label class="mt-radio">
                    <input type="radio" value="0" name="userradio-6" class="userradio-no" checked="checked"
                           disabled="disabled"> No
                    <span></span>
                  </label>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
          <br>
        </div>
      </div>
      <button class="btn green mt-ladda-btn ladda-button account-btn-create-user" data-style="expand-left"
              type="submit">
        <span class="ladda-label">Create User</span>
      </button>
      <router-link :to="{name:'Manage Account List'}" tag="button" class="btn default">
        Cancel
      </router-link>
      <router-link :to="{name:'Manage Account List'}" tag="button" class="btn green pull-right"
                   v-if="logged.access > 5">
        Account Directory
      </router-link>
    </form>
    <br>
    <vue-good-table
        :columns="columns"
        :rows="accounts.users"
        :pagination-options="{enabled: true}"
        v-if="accounts.users != null && accounts.users.length"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'fullName'">
          <a @click.prevent="showUserModal(props.row.id)">{{ props.row.fullName }}</a>
        </span>

        <span v-else-if="props.column.field == 'lastLogin'">
          <span v-if="!props.row.confirmed" @click.prevent="resendActivation(props.row.id)"><a> Resend Activation </a></span>
          <span v-else-if="props.row.lastLogin">{{ props.row.lastLogin | formatDate }}</span>
        </span>

        <span v-else-if="props.column.field == 'access'">
          {{ userRoles[props.row.access] }}
        </span>

        <span v-else-if="props.column.field == 'enabled'">
          <div class="last-dropdown">
              <actions-menu>
                <actions-menu-item
                  v-if="!(logged.access < 6 && props.row.access == 6)"
                  :title="(props.row.enabled) ? 'Deactivate' : 'Activate'"
                  :icon="(props.row.enabled) ? 'fa-remove' : 'fa-check'"
                  @click.prevent="toggleActivation(props.row.id)"
                />
                <actions-menu-item
                  title="Show Activity"
                  icon="fa-list-ul"
                  @click.prevent="showActivityModal(props.row.id)"
                />
                <actions-menu-item
                  title="Show User Access"
                  icon="fa-lock"
                  @click.prevent="showUserAccessModal(props.row.id)"
                />
              </actions-menu>
            </div>
        </span>

        <span v-else>{{props.formattedRow[props.column.field]}}</span>
      </template>
    </vue-good-table>

    <user-activity-log-modal v-if="displayActivityModal" :id="activityLogUserId" v-on:hide="displayActivityModal = false"></user-activity-log-modal>

    <user-access-modal v-if="displayUserAccessModal" :id="userAccessUserId" v-on:display="displayUserAccessModal = $event"></user-access-modal>

  </div>
</template>
<script>
  import {mapActions, mapGetters} from 'vuex';
  import DatePicker from 'vue2-datepicker';
  import {getUserInfo} from "@/http-common";
  import UserActivityLogModal from "../../pages/UserActivityLogModal";
  import UserAccessModal from "../modals/UserAccessModal";
  import ActionsMenu from "../reusables/ActionsMenu";
  import ActionsMenuItem from "../reusables/ActionsMenuItem";
  import participantDisplayName from '@/mixins/participantDisplayName';

  export default {
    mixins: [
      participantDisplayName
    ],
    data() {
      return {
        picked: 2,
        columns: [
          {
            label: 'Full Name',
            field: 'fullName',
            filterOptions: {enabled: true}
          },
          {
            label: 'Email Address',
            field: 'email',
            filterOptions: {enabled: true}
          },
          {
            label: 'ID',
            field: 'id',
            type: 'number',
            thClass: 'vgt-left-align',
            tdClass: 'vgt-left-align',
            filterOptions: {enabled: true}
          },
          {
            label: 'Last Login',
            field: 'lastLogin',
            filterOptions: {enabled: true}
          },
          {
            label: 'Access',
            field: 'access',
            type: 'number',
            thClass: 'vgt-left-align',
            tdClass: 'vgt-left-align',
            filterOptions: {
              enabled: true,
              filterFn: this.accessFilterFn,
            }
          },
          {
            label: 'Action',
            field: 'enabled',
            type: 'boolean',
            thClass: 'vgt-left-align',
            tdClass: 'vgt-left-align',
            filterOptions: {
              enabled: true,
              filterValue: 'Deactivate',
              filterDropdownItems: ['Deactivate', 'Activate'],
              filterFn: this.actionFilterFn,
            }
          },
        ],
        userRoles: [
          '',
          'Referral User',
          'Volunteer',
          'Case Manager',
          'Supervisor',
          'Program Administrator',
          'System Administrator'
        ],
        local: {
          dow: 0, // Sunday is the first day of the week
          hourTip: 'Select Hour', // tip of select hour
          minuteTip: 'Select Minute', // tip of select minute
          secondTip: 'Select Second', // tip of select second
          yearSuffix: '', // suffix of head year
          monthsHead: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), // months of head
          months: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), // months of panel
          weeks: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_') // weeks
        },
        activityLogUserId: null,
        displayActivityModal: false,
        userAccessUserId: null,
        displayUserAccessModal: false
      }
    },
    inject: {
      $validator: '$validator'
    },
    components: {
      UserAccessModal,
      UserActivityLogModal,
      DatePicker,
      ActionsMenu,
      ActionsMenuItem,
    },
    computed: {
      ...mapGetters({
        logged: 'getUser',
        accounts: 'account',
        user: 'currentUser',
        errorBag: 'accountErrorBag'
      }),
      calendarFormat() {
        return getUserInfo('date_format');
      },
      activationDate: {
        get: function () {
          if (this.accounts.activationDate != null) {
            return this.$options.filters.formatDateModal(this.accounts.activationDate['date']);
          }
        },
        set: function () {
        }
      }
    },
    methods: {
      ...mapActions({
        addUser: 'ADD_USER_ACTION',
        loadUser: 'GET_USER_ACTION',
        resendActivation: 'RESEND_ACTIVATION_ACCOUNT_ACTION',
        toggleActivation: 'TOGGLE_ACTIVATION_ACCOUNT_ACTION',
      }),
      renderErrors() {
        this.errors.clear('mu');
        Object.keys(this.errorBag).forEach(obj => {
          this.errors.add(obj, this.errorBag[obj][0], 'auth', 'mu');
        });
      },
      onSubmit() {
        const currentUsersCount = this.accounts.users.filter(u => u.enabled === true).length;

        if (this.accounts.usersLimit !== 0 && currentUsersCount >= this.accounts.usersLimit) {
          this.$notify({
            type: 'error',
            text: 'Unable to Add New User: You have reached your total allocated number of user licenses, please deactivate a current user to add a new user or contact CaseMGR support to purchase additional user licenses.'
          });
        } else {
          this.errors.clear('mu');
          this.$validator.validateAll('mu').then(result => {
            if (result) {
              let context = Ladda.create(document.querySelector('.account-btn-create-user'));
              this.addUser({context, access: this.picked});
            }
          });
        }
      },
      showUserModal(id) {
        this.loadUser({id, account_id: this.accounts.id});
        $('#profile_modal_user').modal('show');
      },
      showUserAccessModal(id) {
        this.userAccessUserId = id;
        this.displayUserAccessModal = true;
      },
      showActivityModal(userId) {
        this.activityLogUserId = userId;
        this.displayActivityModal = true;
      },
      actionFilterFn(data, filterString) {
        let str = data ? 'Deactivate' : 'Activate';
        return str.toLowerCase() === filterString.toLowerCase();
      },
      accessFilterFn(data, filterString) {
        let str = this.userRoles[data].toLowerCase();
        return str.indexOf(filterString.toLowerCase()) !== -1;
      }
    },
    watch: {
      errorBag: function () {
        this.renderErrors();
      },
      picked: function () {
        $("input.userradio-no").not($("input[name='userradio-" + this.picked + "']")).prop("checked", true);
      }
    }
  }
</script>
<style scoped>
  @media (min-width: 768px) {
    .mt-radio-inline {
      min-width: 130px;
    }
  }

  .good-table {
    margin-top: 20px;
  }

  .datepicker {
    width: 100%;
  }

  .table.table-light > tbody > tr > td {
    padding: 0px 10px 0px 0px;
  }

  .last-dropdown {
    width: auto;
  }

  .dropdown-menu {
    left: -110px;
  }

  .dropdown > .dropdown-menu:before, .dropdown-toggle > .dropdown-menu:before, .btn-group > .dropdown-menu:before {
    left: 140px;
  }

  .btn-group > .dropdown-menu:after {
    left: 141px;
  }
</style>



// WEBPACK FOOTER //
// ManageUsersForm.vue?9b4c66e2